"use strict";

module.exports = function () {
    // let $win = $(window),
    //     $main = $("#maincontent"),
    //     $mHeaderRich = $(".m-header-rich"),
    //     $banner = $(".header-banner"),
    //     navPos = $mHeaderRich.offset().top,
    //     fixedClass = "fixed",
    //     addPaddingTop = $("header").outerHeight(),
    //     stickyHeaderHeight =
    //         $mHeaderRich.outerHeight() + $("nav").outerHeight();
    // // $win.on("load scroll", function () {
    // //     let value = $(this).scrollTop();
    // //     if (value > navPos) {
    // //         $banner.css("display", "none");
    // //         $("header").addClass(fixedClass);
    // //         $main.css("padding-top", addPaddingTop);
    // //     } else {
    // //         $banner.css("display", "block");
    // //         $("header").removeClass(fixedClass);
    // //         $main.css("padding-top", "0");
    // //     }
    // // });
    // $('a[href^="#"]').click(function () {
    //     let speed = 100;
    //     let href = $(this).attr("href");
    //     let target = $(href == "#" || href == "" ? "html" : href);
    //     let position;
    //     // // お知らせバナーが非表示かつヘッダがスティッキーではない
    //     // if ($banner.css('display') === 'none' && $('header').css('position') === 'static') {
    //     //     position =
    //     //         target.offset().top -
    //     //         stickyHeaderHeight -
    //     //         $banner.outerHeight();
    //     //     // お知らせバナーが表示かつヘッダがスティッキーではない、またはヘッダがスティッキー状態
    //     // } else {
    //     position = target.offset().top - stickyHeaderHeight;
    //     // }
    //     $("body,html").animate({ scrollTop: position }, speed, "swing");
    //     return false;
    // });
};
